import Button, { ButtonVariants } from '@components/tailwind/Button';
import ProductCardFeatures from '@features/shop/components/product-card/Features';
import { ShopItemGroupItem } from '@types';
import React, { memo, useMemo } from 'react';
import WebImage from '@components/tailwind/WebImage';
import Ribbon from '@components/tailwind/Ribbon';

type Props = {
  item: ShopItemGroupItem;
  features: string[];
  buttonVariant?: ButtonVariants;
  buttonText?: string;
  appendUrl?: string;
};

const CompactProductCard = ({
  item,
  features,
  buttonVariant = 'primary',
  buttonText = 'Shop Now',
  appendUrl = '',
}: Props) => {
  const { isClearance, itemUrl, isLimitedEdition, isNew, isOnSale } = useMemo(() => {
    return {
      isClearance: item?.pickerVariants?.colors?.some?.((c) => c.isClearance),
      itemUrl: item.variantUrl ?? item.url,
      isLimitedEdition: item?.isLimitedEdition ?? false,
      isNew: item?.isNew ?? false,
      isOnSale: item?.isOnSale,
    };
  }, [item]);

  return (
    <div className='tw-relative tw-h-full tw-w-full tw-rounded-lg tw-border tw-border-neutrals-light-grey tw-bg-white tw-p-5'>
      {((isOnSale && !isClearance) || isNew || isLimitedEdition) && (
        <div className='tw-absolute tw-top-2 tw-right-3 tw-z-30'>
          {isOnSale && !isClearance ? (
            <Ribbon padding='4px 12px' fontSize='12px'>
              SALE
            </Ribbon>
          ) : isNew ? (
            <Ribbon padding='4px 12px' fontSize='12px' backgroundColor='#4195B3'>
              New
            </Ribbon>
          ) : (
            isLimitedEdition && (
              <Ribbon padding='4px 12px' fontSize='12px' backgroundColor='rgb(249,115,22)'>
                Limited Edition
              </Ribbon>
            )
          )}
        </div>
      )}
      <div className='tw-mb-5'>
        <WebImage
          webImage={item.webImages.default.active}
          alt={item.displayName}
          className='tw-mx-auto tw-block tw-h-full tw-max-h-[150px] tw-max-w-full'
        />
      </div>

      <div className='tw-mb-1 tw-flex tw-justify-center tw-gap-8'>
        <p className='tw-mb-0 tw-text-center tw-text-base tw-font-bold tw-uppercase tw-text-brand-black'>
          {item.displayName}
        </p>
      </div>

      <ProductCardFeatures features={features} />

      <div className='tw-mt-10 tw-text-center'>
        <Button href={itemUrl + appendUrl} variant={buttonVariant}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default memo(CompactProductCard);
